export const routes = [
  ...require('./structure/routes').routes
]
